export const CCC_HEADER_CLASSNAME = 'ccc-header';
export const GAME_UI_HEADER_CLASSNAME = 'game-ui-header';
